import { render, staticRenderFns } from "./PortalNodeList.vue?vue&type=template&id=12c60d77"
import script from "./PortalNodeList.ts?vue&type=script&lang=ts"
export * from "./PortalNodeList.ts?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.0.10@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports